import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useSidebar } from "../../context/SidebarContext";
import { Sidebar } from "./Sidebar";
import { Toaster } from "../ui/sonner";
import { cn } from "../../lib/utils";

export const MainLayout = () => {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  const { isCollapsed } = useSidebar();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-slate-600">{t("app.loading")}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario debe cambiar la contraseña, redirigir a la página de cambio
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  // Los vigilantes usan la interfaz de patrulla, que incluye su propio control de visitas
  if (user.role === "vigilante") {
    const target = location.pathname.startsWith("/visitors")
      ? location.pathname.replace(/^\/visitors/, "/patrol/visitors") + location.search
      : "/patrol";
    return <Navigate to={target} replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <main 
        className={cn(
          "h-screen overflow-y-auto transition-all duration-300",
          isCollapsed ? "lg:ml-[80px]" : "lg:ml-[280px]"
        )}
      >
        <div className="min-h-full p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
